import React, { useReducer } from 'react'
import { useTranslation } from 'react-i18next'
import CommonContext from './commonContext'
import CommonReducer from './commonReducer'
import { apiCall } from '@/product//common/api'
import { response } from '@/product//context/common'

import {
    COMMON_VALUES,
    COUNT_DATA,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    CLEAR_PINCODE,
    SWITCH_LANGUAGE,
    SET_MEMBERSHIP,
    PIN_CODE_VALID,
    SOCKET_MODAL,
    MODEL_DATA,
} from './commonTypes'

const CommonState = (props) => {
    const initialState = {
        allCategory: [],
        allBusinessCategory: [],
        allOrganization: [],
        allVatCategory: [],
        allLocations: [],
        allTimeZone: [],
        allEventType: [],
        allCondition: [],
        allUISettings: [],
        allSubCategories: [],
        alldata_all_dropdown: [],
        allNotifications: [],
        allConfigurationVariables: { country_code: '+91' },
        allMaintanenceData: null,
        configFeatures: {},
        configVariables: {},
        allBidIncrements: [],
        responseStatus: null,
        languages: [],
        pharases: {},
        currentLanguage: 'for_english',
        allBiddingPlan: [],
        membership: null,
        allHomeBanner: [],
        socketModal: false,
        allModel: [],
        allOem: [],
        allbrand: [],
        allMappingRecords: [],
        pinCodeData: null,
        modelStatus: null,
        statics_count: null,
    }

    const { i18n } = useTranslation()

    const [state, dispatch] = useReducer(CommonReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getGlobalVariable = async (type) => {
        const [res] = await Promise.all([apiCall('post', 'getDefault', {}, '', 'common')])
        if (res?.data?.status && res.data.status === 'success') {
            dispatch({
                type: COMMON_VALUES,
                payload: {
                    allCategory: res.data.data.responseData.tableValues.allcategorytypes,
                    allSubCategories: res.data.data.responseData.tableValues.allsubCategoryTypes,
                    allOrganization: res.data.data.responseData.tableValues.allorganization,
                    allBusinessCategory:
                        res.data.data.responseData.tableValues.allbusiness_category,
                    allVatCategory: res.data.data.responseData.tableValues.allvat_registration,
                    allNotifications: res.data.data.responseData.tableValues.allall_notifications,
                    allTimeZone: res.data.data.responseData.tableValues.alltime_zone,
                    allEventType: res.data.data.responseData.tableValues.allevent_type,
                    allConfigurationVariables: res.data.data.responseData.variables,
                    allMaintanenceData: res.data.data.responseData.maintanenceData,
                    allLocations: res.data.data.responseData.tableValues.alllocations,
                    allMasterBanks: res.data.data.responseData.tableValues.allMasterBanks,
                    allCondition: res.data.data.responseData.tableValues.allconditiontypes,
                    allUISettings: res.data.data.responseData.tableValues.allui_settings,
                    allBidIncrements: res.data.data.responseData.allBidIncrements,
                    bidIncrementDefault: res.data.data.responseData.bidIncrementDefault,
                    alldata_all_dropdown: res.data.data.responseData.tableValues
                        .alldata_all_dropdown
                        ? res.data.data.responseData.tableValues.alldata_all_dropdown.filter(
                              (value) => value.active != 2,
                          )
                        : [],
                    configFeatures: res.data.data.responseData.features,
                    configVariables: res.data.data.responseData.variables,
                    languages: res.data.data.responseData.languages,
                    phrases: res.data.data.responseData.phrases,
                    allBiddingPlan: res.data.data.responseData.tableValues.allbidding_plan,
                    allHomeBanner: res.data.data.responseData.tableValues.allhome_banner?.filter(
                        (value) => value.active === 1,
                    ),
                    allOem: res.data.data.responseData.tableValues?.allbrand_store || [],
                    allMappingRecords:
                        res.data.data.responseData.tableValues.allgroup_cat_brand_map?.filter(
                            (value) => value.status != 2,
                        ),
                    allModel: res.data.data.responseData.tableValues.allmodel?.filter(
                        (value) => value.status != 2,
                    ),
                    allbrand: res.data.data.responseData.tableValues.allbrand.filter(
                        (value) => value.status != 2,
                    ),
                },
            })

            //set reload the language phrase
            global.languages = res.data.data.responseData.languages
            global.phrases = res.data.data.responseData.phrases
            for (let i = 0; i < global.languages.length; i++) {
                i18n.addResourceBundle(
                    global.languages[i],
                    'translations',
                    global.phrases[global.languages[i]],
                    true,
                    true,
                )
            }
            i18n.changeLanguage('for_english')
        }
    }

    const switchLanguage = (data) =>
        dispatch({
            type: SWITCH_LANGUAGE,
            payload: data,
        })

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    const setCurrentMembership = (payload) =>
        dispatch({
            type: SET_MEMBERSHIP,
            payload: {
                membership: payload,
            },
        })
    const modelData = (data) =>
        dispatch({
            type: MODEL_DATA,
            payload: {
                modelStatus: data,
            },
        })

    const setSocketModal = () => {
        dispatch({
            type: SOCKET_MODAL,
        })
    }
    const clearData = () => {
        dispatch({
            type: CLEAR_PINCODE,
        })
    }

    const pinCodeValidation = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'pinValidation', formData, '', 'commonFunction'),
            ])
            const from = 'pinCodeValid'
            if (res.data.status === 'success') {
                dispatch({
                    type: PIN_CODE_VALID,
                    payload: {
                        record: res.data.data.responseData.record
                            ? res.data.data.responseData.record
                            : {},
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const getCount = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getCount', formData, '', 'commonFunction'),
            ])
            const from = 'getCount'
            if (res.data.status === 'success') {
                dispatch({
                    type: COUNT_DATA,
                    payload: {
                        record: res.data.data.responseData.record
                            ? res.data.data.responseData.record
                            : {},
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    return (
        <CommonContext.Provider
            value={{
                allCategory: state.allCategory,
                allBusinessCategory: state.allBusinessCategory,
                allOrganization: state.allOrganization,
                allVatCategory: state.allVatCategory,
                allNotifications: state.allNotifications,
                allSubCategories: state.allSubCategories,
                allLocations: state.allLocations,
                allCondition: state.allCondition,
                allModel: state.allModel,
                allOem: state.allOem,
                allbrand: state.allbrand,
                allTimeZone: state.allTimeZone,
                allEventType: state.allEventType,
                allUISettings: state.allUISettings,
                allBidIncrements: state.allBidIncrements,
                alldata_all_dropdown: state.alldata_all_dropdown,
                allConfigurationVariables: state.allConfigurationVariables,
                allMaintanenceData: state.allMaintanenceData,
                allBiddingPlan: state.allBiddingPlan,
                membership: state.membership,
                allHomeBanner: state.allHomeBanner,
                configFeatures: state.configFeatures,
                configVariables: state.configVariables,
                languages: state.languages,
                currentLanguage: state.currentLanguage,
                responseStatus: state.responseStatus,
                socketModal: state.socketModal,
                pinCodeData: state.pinCodeData,
                modelStatus: state.modelStatus,
                statics_count: state.statics_count,
                switchLanguage,
                getGlobalVariable,
                clearResponse,
                pinCodeValidation,
                clearData,
                modelData,
                setCurrentMembership,
                setSocketModal,
                getCount,
            }}
        >
            {props.children}
        </CommonContext.Provider>
    )
}

export default CommonState
